import React from 'react';
import { useLocation } from 'react-router-dom';
import { AiAssistant, Button } from '@barracuda-internal/bds-core-v2';
import { useAppDispatch } from 'src/hooks/useAppDispatch';
import { openScheduleDrawerForCreate } from 'src/features/scheduling/schedulingSlice';

const MastheadActions: React.FC = () => {
	const location = useLocation();
	const dispatch = useAppDispatch();
	const isScheduledReportsRoute =
		location.pathname === '/reports/scheduled-reports';

	return (
		<>
			<AiAssistant />
			{isScheduledReportsRoute && (
				<Button
					onClick={() =>
						dispatch(
							openScheduleDrawerForCreate({ context: 'general' }),
						)
					}
				>
					New Schedule
				</Button>
			)}
		</>
	);
};

export default MastheadActions;
